import { Spacer,Box, Flex, Icon, Text, useColorModeValue } from "@chakra-ui/react";
import React, { useState, useRef, useEffect } from "react";

import { RiCheckboxBlankLine,RiFileTextFill,RiCoinsFill,RiFileAddFill,RiAttachmentLine,RiMailFill,RiDeleteBin2Fill,RiEdit2Fill } from "react-icons/ri";
import { FaRegRectangleList,FaShareNodes,FaCommentDots,FaPhone,FaFilePen,FaLink,FaInfo,FaMapLocationDot,FaCirclePlay, FaCirclePlus,FaImages,FaImage,FaChevronUp,FaChevronDown,FaChevronRight,FaChevronLeft} from "react-icons/fa6";
import { IoExit } from "react-icons/io5";
import { GiSoundWaves } from "react-icons/gi";

function MarkerRow(props) {
  const iconColor = useColorModeValue("gray.500", "gray.400");
  const textColor = useColorModeValue("gray.700", "white");
  const { title, icon, size, color,type,action } = props;
  let logos={
    "plus":FaCirclePlus,
    "pointer":FaCirclePlus,
    "video":FaCirclePlay,
    "location":FaMapLocationDot,
    "gallery":FaImages,
    "image":FaImage,
    "sound":GiSoundWaves,
    "exit":IoExit,
    "up":FaChevronUp,
    "right":FaChevronRight,
    "down":FaChevronDown,
    "left":FaChevronLeft,
    "form":FaFilePen,
    "phone":FaPhone,
    "comment":FaCommentDots,
    "share":FaShareNodes,
    "list":FaRegRectangleList,
    "delete":RiDeleteBin2Fill,
    "edit":RiEdit2Fill,
    "email":RiMailFill,
    "attach":RiAttachmentLine,
    "info":FaInfo,
    "link":FaLink,
    "add":RiFileAddFill,
    "buy":RiCoinsFill,
    "text":RiFileTextFill,
    "transparent":RiCheckboxBlankLine,
  }
  
  return (
    <Flex my="1rem" justifyContent="space-between">
    <Flex alignItems="center">
      <Box >
        <Icon w="24px" h="24px" ml="20px" color={color ? color+".400" : iconColor} as={logos[icon]} />
      </Box>
      <Flex direction="column">
        <Text
          fontSize="sm"
          color={textColor}
          fontWeight="bold"
        >
          {title}
        </Text>
        <Text
          fontSize="10px"
          dir="ltr"
          textAlign={"right"}
          color="gray.400"
        >
          {type}
        </Text>
      </Flex>
    </Flex>
    <Box>
      {action}
    </Box>
  </Flex>
  );
}

export default MarkerRow;
